import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Blog2 = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const calculateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight - windowHeight;
      const scrollTop = window.scrollY;
      const progress = (scrollTop / documentHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', calculateScrollProgress);
    return () => window.removeEventListener('scroll', calculateScrollProgress);
  }, []);

  return (
    <article className="blog-article">
      <div className="progress-bar-container">
        <div 
          className="progress-bar"
          style={{ width: `${scrollProgress}%` }}
        />
      </div>

      <Link to="/blogs" className="back-link">
        <span className="mr-2">←</span>
        Terug naar blogs
      </Link>

      <header className="blog-header">
        <div>
          <h1 className="text-3xl font-bold text-[#2B4055] mb-2">Product Owner Excellence</h1>
          <h2 className="text-xl text-[#FF6B35] mb-4">Van goed naar excellent</h2>
          <div className="flex items-center gap-4 text-gray-600">
            <span>17 maart 2024</span>
            <span>•</span>
            <span>4 min leestijd</span>
          </div>
        </div>
      </header>

      <div className="prose">
        <p className="lead">
          Wat maakt een Product Owner echt succesvol? In mijn ervaring gaat het verder dan 
          alleen backlog management en stakeholder communicatie. Het draait om het vermogen 
          om strategisch te denken én pragmatisch te handelen.
        </p>

        <h2>Strategisch denken als basis</h2>
        <p>
          Een excellente Product Owner begrijpt niet alleen het product, maar ook de markt, 
          de gebruikers en de bedrijfsstrategie. Dit grotere perspectief is essentieel voor 
          het maken van de juiste prioriteitskeuzes.
        </p>

        <h2>De balans tussen visie en pragmatisme</h2>
        <p>
          Hoewel een sterke visie belangrijk is, moet een Product Owner ook pragmatisch 
          kunnen handelen. Dit betekent soms moeilijke keuzes maken en de balans vinden 
          tussen korte termijn resultaten en lange termijn doelen.
        </p>

        <blockquote>
          "Een excellente Product Owner is als een dirigent die zorgt dat alle instrumenten 
          samen een prachtig stuk muziek maken."
        </blockquote>

        <h2>Kernvaardigheden voor excellence</h2>
        <ul>
          <li>
            <strong>Strategisch inzicht:</strong> Begrijp de markt en bedrijfsstrategie
          </li>
          <li>
            <strong>Stakeholder management:</strong> Bouw sterke relaties op alle niveaus
          </li>
          <li>
            <strong>Besluitvaardigheid:</strong> Durf keuzes te maken en deze uit te leggen
          </li>
          <li>
            <strong>Technisch begrip:</strong> Snap de mogelijkheden en beperkingen
          </li>
        </ul>

        <h2>De rol van communicatie</h2>
        <p>
          Effectieve communicatie is essentieel voor een Product Owner. Het gaat niet alleen 
          om het overbrengen van informatie, maar ook om het creëren van begrip en draagvlak 
          voor beslissingen. Een excellente Product Owner weet complexe materie eenvoudig uit 
          te leggen en verschillende stakeholders op hun eigen niveau te benaderen.
        </p>

        <h2>Datagedreven besluitvorming</h2>
        <p>
          Een excellente Product Owner baseert beslissingen op data en inzichten, niet alleen 
          op gevoel of meningen. Dit betekent het constant meten en analyseren van productprestaties, 
          gebruikersgedrag en markttrends om weloverwogen keuzes te maken.
        </p>

        <h2>Conclusie</h2>
        <p>
          Excellence als Product Owner is een continu proces van ontwikkeling. Door de juiste 
          balans te vinden tussen strategie en uitvoering, en door consequent te focussen op 
          waarde voor de gebruiker, kun je groeien van goed naar excellent. Het vereist een 
          combinatie van vaardigheden, maar vooral de wil om te blijven leren en verbeteren.
        </p>
      </div>
    </article>
  );
};

export default Blog2;